<template>
<div class="chapter">
<div class="inner_page">
<p class="ctp"><span><a href="#/Book1/content#tree37" id="terr37">Part Two</a><br/><a href="#/Book1/content#tree37">The <i>Narcissus</i></a></span></p>
<p class="ct1"><span>Wednesday Afternoon to Saturday Afternoon</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_Two.vue?451934dc